import { Div, Button } from '@codesuma/baseline'
import style from './index.module.css'

// WizardNav — the progress dots and the controls, pinned to the bottom of the
// panel. Sits outside the sliding stage so it never moves.
//
// Three rows. The dots, then the way on across the full width, then the two
// ways out beside each other. The way on is the one thing the reader is looking
// for, so it gets the width and the ink; stepping back and stopping early are
// both secondary, and they share the row under it.
//
// The way out before the end is there when the flow says so: every step after
// the name only adds to what is already saveable, so a wizard that has enough
// should say so rather than march the reader past questions they have no answer
// for. Its row disappears entirely when neither button is due.
//
// Emits 'prev', 'next' and 'done'.

export interface INavState {
    steps: number
    index: number
    nextLabel: string
    nextEnabled: boolean
    showPrev: boolean
    // The caller decides when there is enough to save — it is the only one that
    // knows. Left out entirely by a flow that has no such shortcut.
    showDone?: boolean
    doneLabel?: string
}

export const WizardNav = () => {
    const base = Div()
    base.addClass(style.nav)

    const dots = Div()
    dots.addClass(style.dots)

    const buttons = Div()
    buttons.addClass(style.navButtons)

    const next = Button('ادامه')
    next.addClass(style.primaryBtn)
    next.on('click', () => base.emit('next'))

    const prev = Button('قبلی')
    prev.addClass(style.secondaryBtn)
    prev.on('click', () => base.emit('prev'))

    const done = Button()
    done.addClass(style.doneBtn)
    done.on('click', () => base.emit('done'))

    buttons.append(prev, done)
    base.append(dots, next, buttons)

    const setState = ({ steps, index, nextLabel, nextEnabled, showPrev, showDone, doneLabel }: INavState) => {
        dots.empty()
        for (let i = 0; i < steps; i++) {
            const dot = Div()
            dot.addClass(style.dot)
            dot.toggleClass(style.dotActive, i === index)
            dot.toggleClass(style.dotDone, i < index)
            dots.append(dot)
        }

        next.text(nextLabel)
        next.el.disabled = !nextEnabled
        next.toggleClass(style.btnDisabled, !nextEnabled)

        // Taken out of the row rather than hidden in it, so whichever is left
        // spans it instead of sitting off to one side — and the row itself goes
        // when neither is due, rather than leaving a band of air under the
        // button.
        prev.style({ display: showPrev ? '' : 'none' })
        done.text(doneLabel || 'ذخیره و پایان')
        done.style({ display: showDone ? '' : 'none' })
        buttons.style({ display: showPrev || showDone ? '' : 'none' })
    }

    return Object.assign(base, { setState })
}
